export default "__VITE_ASSET__B_U0ayyy__"